import { Deserializable } from '../_common/deserializable';

export class DnRecord implements Deserializable{
    id: string;
    msgId: string;
    country: string;
    telco: string;
    telcoId: string;
    shortCode: string;
    keyword: string;
    operator: string;
    phone: string;
    msisdn: string;
    transactionAtOrigin: string;
    transactionAt: string;
    createdAt: string;
    panOutState: number;
    panOutAt: string;
    panOutMsg: string;
    panOutTimes: number;
    status: string;
    statusMsg: string;
    receivedAt: string;
    charge: string;

    deserialize(input: any): this {
      return Object.assign(this, input);
    }
}
